import { cloneElement, ReactElement } from 'react';

export const DEFAULT_COMPONENTS = {
  ol: <ol className="space-y-2 *:first:mt-2" />,
  ul: <ul className="space-y-2 *:first:mt-2" />,
  li: <li className="ms-4 list-disc" />,
  b: <span className="font-bold" />,
  a: <a target="_blank" className="underline hover:text-procuros-green-400" />,
  br: <br />,
  div: <div />,
  code: <code className="rounded-md border border-gray-200 bg-white px-1 py-0.5 text-xs text-procuros-green-700" />,
};

export const mergeWithDefaultComponents = (overrides: Record<string, ReactElement>): Record<string, ReactElement> => {
  const merged: Record<string, ReactElement> = {};
  for (const [key, element] of Object.entries(overrides)) {
    const defaultElement = DEFAULT_COMPONENTS[key as keyof typeof DEFAULT_COMPONENTS];
    if (defaultElement && element.type === defaultElement.type) {
      const overrideProps = element.props as Record<string, unknown>;
      const mergedClassName =
        [defaultElement.props.className, overrideProps.className].filter(Boolean).join(' ') || undefined;
      merged[key] = cloneElement(defaultElement, {
        ...overrideProps,
        ...(mergedClassName ? { className: mergedClassName } : {}),
      });
    } else {
      merged[key] = element;
    }
  }
  return merged;
};
